export default __webpack_public_path__ + "static/media/rediseño.6f5dd51e.svg";